import { YANDEX_METRICS_ID } from '@shared/constants/global';

export const getClientId = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    const ym = window.ym;

    if (ym) {
      try {
        ym(YANDEX_METRICS_ID, 'getClientID', (clientId: string) => {
          resolve(clientId);
        });
      } catch (e) {
        reject(e);
      }
    }
  });
};
